module.exports = __webpack_public_path__ + "img/chinesecompany181.b71330ce.png";